<template>
  <div class="order-list tt-custom-tab">
    <div class="search-bar seprator">
      <div>
        <el-select style="width:170px;"
                          v-model="form.shipping_company_id"
                          clearable
                          filterable
                          :filter-method="remotetransportSearch"
                          class="input-width"
                          placeholder="物流公司">
                          <el-option
                            v-for="item in remoteTrasports"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id"></el-option>
          </el-select>
      </div>
      <div style="margin-left:10px;">
        <el-select style="width:110px" v-model="form.monitor_type" class="mobile-select" placeholder="监控类型">
          <el-option label="监控类型" value=""></el-option>
          <el-option v-for="(p, index) in monitor_types" :key="index" :label="p.value"
            :value="p.id"></el-option>
        </el-select>
      </div>
      <div style="margin-left:10px;">
        <el-select style="width:110px" v-model="form.group_tag" class="mobile-select" placeholder="分组">
          <el-option label="分组" value=""></el-option>
          <el-option v-for="(p, index) in groups" :key="index" :label="p"
            :value="p"></el-option>
        </el-select>
      </div>
      <div style="margin-left:10px;">
        <el-select v-if="merchantOrExpress == 1" style="width:170px;" v-model="form.related_merchant_id" clearable filterable :filter-method="filterSearch"
          class="combo-right input-width" placeholder="商家">
          <el-option v-for="item in merchantOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
        </el-select>
      </div>
      <div style="margin-left:10px;">
        <el-select style="width:110px" v-model="form.monitor_flag" class="mobile-select" placeholder="监控开关">
          <el-option label="监控开关" value=""></el-option>
          <el-option label="开启" value="1"></el-option>
          <el-option label="关闭" value="0"></el-option>
        </el-select>
      </div>
      <div style="margin-left:10px;">
        <el-button type="primary" @click="openTicket">创建监控</el-button>
      </div>
    </div>
    <div class="search-bar seprator">
      <div style="display:flex;align-items:center;">
        <span>
            {{totalCount}}个监控&nbsp;&nbsp;
        </span>
      </div>
      <!--<div style="display:flex;align-items:center;">
        <div style="margin-right:5px;display:flex;align-items: center;">
          <el-select style="width:110px;" v-model="timeRangeType" class="combo-left mobile-select">
            <el-option label="创建时间" :value="1"></el-option>
            <el-option label="更新时间" :value="2"></el-option>
          </el-select>
          <span class="combo-right">
            <el-date-picker format="yyyy-MM-dd HH:mm" v-model="form.date_range" type="datetimerange" range-separator="至" start-placeholder="开始时间"
              end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </span>
        </div>
        <div>
          <el-input class="commbo-input" style="width:500px;" clearable
            v-model="searchWord" placeholder="监控关键字">
            <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
          </el-input>
        </div>
      </div>-->
      <div style="margin-left:10px;">
        <el-input class="commbo-input" style="width:500px;" clearable
            v-model="form.related_task_id" placeholder="任务">
            <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
          </el-input>
      </div>
    </div>
    <div class="table">
      <div class="table-head">
        <div v-for="c in columns" :style="{width:c.width}">
          {{ c.name }}
        </div>
      </div>
      <div class="table-body pool">
        <div class="table-row-title" v-for="(r,idx) in mailList" :key="idx" style="width:100%;">
          <div v-for="(c,idx) in columns" :key="idx" :style="{width:c.width}">
            <template v-if="c.field=='send_time_display'">
              <p style="font-size: 16px;padding-bottom: 5px;">
                <label>物流公司：</label>
                <label>{{ expressList?expressList.find(e=>e.id==r.shipping_company_id).name:'' }}</label>
              </p>
              <p style="font-size: 16px;padding-bottom: 5px;">
                <label>物流单号：</label>
                <a :href="r.shipping_link">{{ r.shipping_number }}</a>
              </p>
            </template>
            <template v-if="c.field=='mail_content'">
              <p style="font-size: 16px;padding-bottom: 5px;">
                
              </p>                    
            </template>
            <template v-if="c.field=='status_display'">
              <p style="font-size: 16px;;padding-bottom: 5px;">
                <label>任务号</label>
                <label>{{ r.related_task_id }}</label>
              </p>
              <p style="font-size: 16px;;padding-bottom: 5px;">
                <label>分组</label>
                <label>{{ r.group_tag }}</label>
              </p>
            </template>
            <template v-if="c.field=='operation'">
              <el-switch
                v-model="r.monitor_flag"
                active-color="#000"
                active-text="开启"
                inactive-text="关闭"
                active-value="1"
                inactive-value="0"
                @change="updateMonitor(r)">
              </el-switch>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="yd-pagination" v-if="totalCount / form.limit > 1">
      <el-pagination :page-size="form.limit" :pager-count="5" :current-page.sync="form.page" layout="prev, pager, next"
        next-text="下一页" prev-text="上一页" :total="totalCount" @current-change="search">
      </el-pagination>
    </div>
    <AddMonitor :expressList="expressList" :merchants="merchants" @fetchTicket="search"></AddMonitor>
    <Empty v-if="totalCount == 0" class="empty-content" title="监控"></Empty>
  </div>
</template>

<script>
import AddMonitor from './AddMonitor'
import Empty from '../snatch/Empty'
import api from '../../../services/api.js'
let _ = require('lodash')

export default {
  name: 'OrderList',
  components: {
    AddMonitor:AddMonitor,
    Empty:Empty
  },
  data() {
    return {
      shipping_types:[{id:1,value:'商家物流'},{id:2,value:'转运物流'},{id:3,value:'终端物流'}],
      monitor_flags:[{id:1,value:'开启'},{id:0,value:'关闭'}],
      monitor_types:[{id:1,value:'物流进展'},{id:2,value:'包裹揽收'}],
      merchantOrExpress:1,
      timeRangeType:1,
      account_id:this.$localStorage.get('account_id'),
      multipleUpdating:false,
      activeName: '0',
      mailList: [],
      columns: [
        { name: '物流', field: 'send_time_display',width:'300px' },
        { name: '最新状态', field: 'mail_content',width:'calc(100% - 630px)' },
        { name: '关联', field: 'status_display',width:'200px' },
        { name: '操作', field: 'operation',width:'150px' },
      ],
      keyword_type: '2',
      searchWord: '',
      ticketTypes: [],
      ticketStatus: [],
      ticketStatusOptions: [],
      ticketPriorities:[],
      ticketVisible:[],
      form:{
        limit:30,
        page:1,
        shipping_company_id:'',
        monitor_type:'',
        group_tag:'',
        related_merchant_id:'',
        related_task_id:'',
        monitor_flag:''
      },
      totalCount:-1,
      singleList: [],
      singleListOptions: [],
      assignTo:[],
      merchants:[],
      merchantOptions:[],
      remoteTrasports:[],
      expressList:[],
      status_arr:[],
      groups:[]
    }
  },
  async mounted() {
    await this.getSingleList()  
    await this.getExpressList()
    await this.getOrdersMerchants()
    await this.getMonitorGroupList()
    this.search()
  },
  methods: {
    async updateMonitor(r){
      console.log('test',r)
      //let res = await api.updateMonitor(this,r)
    },
    async getMonitorGroupList () {   
      let res = await api.getMonitorGroupList(this)
      //console.log('groups',res)
      this.groups=res.body.result;  
    },
    openTicket(){
      let productCancelDialog = document.getElementById('addmonitor')
      productCancelDialog.click()
    },
    changeMerchatOrExpress(){
      if(this.changeMerchatOrExpress==1)
        this.form.transport_express_id=''
      else
        this.form.merchant_id=''
    },
    async getExpressList(){
      let res = await api.getExpressList(this,'')
      this.expressList=res.body.result;
    },
    remotetransportSearch(queryString,callback){
      this.remoteTrasports=[]
      let res=this.expressList.filter((i)=>{
        return i.name.toLowerCase().indexOf(queryString.toLowerCase())>-1
      })
      _.each(res,item => {
        if(item.type == '2') {
          this.remoteTrasports.push({value:item.name,id:item.id})
        }
      })
      if(callback)
          callback()
    },
    async getOrdersMerchants() {
      let res = await api.getOrdersMerchants(this, {})
      res = res.body
      this.merchants = res.result
      
    },
    filterSearch(val) {
      this.merchantOptions = []
      let mers = [];
      if (val) {
        mers = this.merchants.filter((item) => {
          return item.merchant_name.toLowerCase().indexOf(val.toLowerCase()) > -1
        })
      }
      else {
        mers = this.merchants;
      }
      mers.forEach(item => {
        this.merchantOptions.push({ value: item.merchant_name, id: item.merchant_id })
      })
    },
    async getTicketVisible() {   
      let res = await api.getTicketVisible(this)
      this.ticketVisible=res.body.result     
    },
    async getSingleList () {   
      let res = await api.getTicketAccounts(this)
      this.singleList=res.body.result    
      this.singleListOptions=[{id:'',name:'全 部'}].concat(this.singleList) 
    },
    async getTicketStatus () {   
      let res = await api.getTicketStatus(this)
      this.ticketStatus=res.body.result
      this.ticketStatusOptions=[{id:'',name:'全 部'}]
      this.ticketStatus.forEach((t)=>{
        let tt = JSON.parse(JSON.stringify(t))
        if(t.next_level_list.length==0)
          delete tt.next_level_list
        this.ticketStatusOptions.push(tt)
      })   
    },
    async getTicketTypes(){
      let res = await api.getTicketTypes(this)
      this.ticketTypes=res.body.result    
    },
    async getTicketPriorities(){
      let res = await api.getTicketPriorities(this)
      this.ticketPriorities=res.body.result    
    },
    search(){
      const generateParams=()=>{
        let params=this.form      
        return params
      }
      let params=generateParams()
      this.getList(params)
    },
    async changeCollapse(data){
      let mail=this.mailList[data]
      if(mail.comments)
        return
      let params={}
      params.ticket_id=mail.id
      let res = await api.getTicketComments(this, params)
      mail.comments = res.body.result
      mail.comments.forEach((i)=>{
        i.replyDateDisplay=this.generateDateDisplay(i.replied_date.split(' ')[0])
        i.replyTimeDisplay=i.replied_date.split(' ')[1]
        i.editMode=false       
      })
      this.$set(this.mailList[data],0,mail) 
      //this.mailList[data]=mail;
      this.$forceUpdate()
    },
    async updateMail(index){
      let mail = this.mailList[index]
      mail.updating=true
      let res=await api.updateMailInfo(this,{id_list:[mail.id],status:mail.status})
      if(res.body.status!='ok'){
        mail.status=mail.status=='1'?'2':'1'
      }
      mail.updating=false
      mail.status_display=this.mailStatus[mail.status]
      this.mailList[index]=Object.assign({},mail)
      this.$forceUpdate()
    },
    generateDateDisplay(datestring){
      let today=new Date()
      let yesterday=new Date(today.getTime() -24*60*60*1000)
      let today_string=this.$moment(today).format('YYYY-MM-DD')
      let yest_string=this.$moment(yesterday).format('YYYY-MM-DD')
      if(datestring==today_string)
        return '今天';
      if(datestring==yest_string)
        return '昨天';
      return datestring
    },
    getList(params) {
      api.getMonitorList(this, params).then((res) => {
        this.mailList = res.body.result.rows;
        this.totalCount=+res.body.result.total;
        if(this.mailList){
          this.mailList.forEach((i)=>{
            if(i.created_date){
              i.createDateDisplay=this.generateDateDisplay(i.created_date.split(' ')[0])
              i.createTimeDisplay=i.created_date.split(' ')[1]
            }
          })
        }
      })
      delete params.page
      delete params.limit
    },
    async getMailThemes(){
      let res = await api.getMailThemes(this)
      res = res.body
      let types = res.result
      this.mailTypes = [{name:'',label:'邮件主题'}]
      types.forEach(item => {
        this.mailTypes.push({ name: item,label: item })
      })

    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.empty-content {
  padding: 50px 0 50px;
}
.tag-label{
  background:black;
  color:white;
  display: inline-block;
  height: 30px;
  padding: 0 5px;
  border-radius: 5px;
  line-height: 30px;
}
.priority-label{
    display: inline-block;
    width:16px;
    height:16px;
    border-radius: 2px;
    position: relative;
    top:3px;
    &.P1{
      background-color: #FF4650;
    }
    &.P2{
      background-color: #e6a23c;
    }
    &.P3{
      background-color: #409eff;
    }
    &.P4{
      background-color: #909399;
    }
  }
</style>

<style lang="scss" scoped>
.order-list {
  margin-bottom: 80px;

  .el-tabs__content {
    overflow: visible;
  }
}

.search-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom:10px;
  &.seprator{
    justify-content: space-between;
  }
}
.table{
  margin-top:43px;
  overflow-x:auto;
  overflow-y:hidden;
  .table-head,
  .table-body{
    display: flex;
  }
  .table-head{
    padding: 18px 11px 18px 21px;
  }
  .table-row-title{
    display: flex;
    padding:18px 11px 18px 21px;
    border-top:1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }
  .table-head{
    color:#888888;
  }
  .seporater-order{
      padding: 0 50px;
      height: 40px;
      border: 1px solid #D7D7D7;
      border-top:none;
      line-height: 40px;
    }
  .table-row-content{
    //display:flex;
    padding:25px 50px 30px;
    border: 1px solid #D7D7D7;
    border-top:none;
    &.order{
      display:block;
      border-top: 1px solid #D7D7D7;
    }
  }
  .table-row-seperator{
    float: left;
    height: 33px;
    width: 100%;
    border-left: 1pX dashed #D7D7D7;
    border-right: 1px dashed #D7D7D7;
  }
}
.yd-pagination{
  margin-top:30px;
}
.redirct {
    font-size:24px;
    line-height:33px;
    margin-top: 54px;
    padding-bottom: 70px;
    .completion {
      background-image: url('../../../assets/images/Group@2x.png');
      background-position: 0 0;
      background-size: contain;
    }
    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
  }
  .product-price label.danger{
    font-size: 18px;
    color:#FF4650;
  }

</style>



// WEBPACK FOOTER //
// src/pages/orders/monitor/list.vue